module.exports = __webpack_public_path__ + "static/media/register_ips.23891128.svg";